import { CUSTOM_FIELDS_TARGET } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';

export const PROPERTY_INFO_CUSTOM_FIELDS_TARGETS = [
  CUSTOM_FIELDS_TARGET.PROPERTY,
  CUSTOM_FIELDS_TARGET.SUBJECT_PROPERTY,
];
